import { render, staticRenderFns } from "./ModificarAsegurados.vue?vue&type=template&id=4eb6b6e9&scoped=true"
import script from "./ModificarAsegurados.vue?vue&type=script&lang=ts"
export * from "./ModificarAsegurados.vue?vue&type=script&lang=ts"
import style0 from "./ModificarAsegurados.vue?vue&type=style&index=0&id=4eb6b6e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb6b6e9",
  null
  
)

export default component.exports